import { FC, useEffect, useRef } from "react";
import { App, URLOpenListenerEvent } from "@capacitor/app";
import { useHistory } from "react-router";
import { appLaunchUrlToPath } from "../utils/AppUrlHelper";
import { useUserLoggedIn } from "./hooks";
import { getUTMParamsFromURL } from "../services/analytics/utmAttribution";
import { mpRegisterSuperProperties } from "../services/analytics/mixpanelService";
import { trackEvent } from "../services/analytics/analyticsService";
import { routes } from "../route/constants";
import { processIosGarminDevices } from "../services/watch/GarminWatchHelper";

/** Deep linking code for Android and iOS */
const AppUrlListener: FC<any> = () => {
    let history = useHistory();
    const loggedIn = useUserLoggedIn();
    const listenerHandleRef = useRef<{ remove: () => Promise<void> | void } | null>(null);
    const loggedInRef = useRef(loggedIn);

    console.log("AppUrlListener called");
    useEffect(() => {
        loggedInRef.current = loggedIn;
    }, [loggedIn]);

    useEffect(() => {
        const registerListener = async () => {
            listenerHandleRef.current = await App.addListener(
                "appUrlOpen",
                async (event: URLOpenListenerEvent) => {
                    const path = appLaunchUrlToPath(event.url);
                    console.log(path);
                    if (!loggedInRef.current) {
                        const redirectDestination = path
                            ? path === "" || path === "/"
                                ? routes.tabResults
                                : path
                            : undefined;

                        if (history.location.pathname === routes.login) {
                            history.replace(routes.login, redirectDestination ? { redirectTo: redirectDestination } : undefined);
                        } else {
                            history.push(
                                routes.login,
                                redirectDestination
                                    ? { redirectTo: redirectDestination }
                                    : undefined
                            );
                        }
                        return;
                    }

                    // Check for Garmin deep link - used for iOS response to getKnownDevices
                    if (event.url.includes("device-select-resp")) {
                        // Dispatch an action to store Garmin params in Redux
                        processIosGarminDevices(event.url).catch((e) => {
                            console.error("Error processing Garmin devices", e);
                        });
                        return;
                    }

                    if (path) {
                        const utmParams = getUTMParamsFromURL(event.url);
                        mpRegisterSuperProperties(utmParams);
                        trackEvent("DeepLinkAppOpen", {
                            urlPath: path,
                            ...utmParams,
                        });

                        if (path === "" || path === "/") {
                            // the fallback route doesn't seem to work by default
                            history.push(routes.tabResults);
                        } else {
                            history.push(path);
                        }
                    }
                    // If no match, do nothing - let regular routing
                    // logic take over
                }
            );
        };

        registerListener();

        return () => {
            if (listenerHandleRef.current) {
                listenerHandleRef.current.remove();
                listenerHandleRef.current = null;
            }
        };
    }, [history]);

    return null;
};

export default AppUrlListener;
